import { AsyncPipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { DetailsComponent } from '../../components/detail/details/details.component';
import { DetailHeaderComponent } from '../../components/detail/header/detail-header.component';
import { LIB_CONFIG, LibConfig } from '../../lib.config';
import { BildungsangebotTerminDetail } from '../../model';
import { BildungsangeboteService } from '../../services/bildungsangebote.service';
import { DetailPageService } from '../../services/detail-page/detail-page.service';
import { ScrollToAndFocusDirective } from '../../shared/directives';
import { BefragungBannerComponent } from '../../components/befragung-banner/befragung-banner.component';

@Component({
  selector: 'now-wbsuche-lib-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
  providers: [DetailPageService],
  imports: [
    ScrollToAndFocusDirective,
    BreadcrumbComponent,
    DetailHeaderComponent,
    DetailsComponent,
    BefragungBannerComponent,
    AsyncPipe
  ]
})
export class DetailComponent {
  private readonly bildungsangeboteService = inject(BildungsangeboteService);
  private readonly detailPageService = inject(DetailPageService);
  libConfig = inject<LibConfig>(LIB_CONFIG);

  @Input()
  set termin(termin: BildungsangebotTerminDetail) {
    this.termin$.next(termin);
  }

  @Input()
  // This is used by other Projects to load the Termin data.
  set termindId(terminId: string) {
    this.bildungsangeboteService.getAktuellenTermin$(terminId).subscribe((termin) => {
      this.termin = termin;
    });
  }

  public termin$ = new ReplaySubject<BildungsangebotTerminDetail>();

  public currentTab$ = this.detailPageService.currentTab$;
}
